/**
 * Actions for post categories
 */
import { keyBy } from "lodash";
import * as actionTypes from "./actionTypes";

/**
 * Action is called to fetch all post categories
 * @param {*} payload Api req parameters
 */
export function fetchCategories(payload) {
  return { type: actionTypes.FETCH_CATEGORIES, payload };
}

/**
 * Action is called to fetch all post categories success
 * @param {*} categories Api res parameters
 */
export function fetchCategoriesSuccess(categories) {
  const byId = keyBy(categories, (cat) => cat.postcategoryUid);
  return { type: actionTypes.FETCH_CATEGORIES_SUCCESS, payload: { byId } };
}
